export default __webpack_public_path__ + "static/media/Aleart.41e4b702.png";